import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { IMPERSONATE_OFF, SWITCH_DOCUSIGN_DROPDOWN } from '../../../redux/types';
import { RootState } from '../../../redux/store';
import Logo from '../../ui/logo/logo';
import UserIcon from '../../ui/userIcon/userIcon';
import ContactTooltip from '../../ui/contactTooltip/contactTooltip';
import ResponsiveNavigation from '../../ui/responsiveNavigation/responsiveNavigation';
import Icon from '../../ui/icon/icon';
import setImpersonationToLS from '../../../common/utility/setImpersonationToLS';
import LogoSize from '../../../common/services/config/brandingStore';
import useForceUpdate from '../../../common/hooks/useForceUpdate';
import './topbar.scss';
import FilterCtx from '../../../context/filterContext/filterCtx';
import DocuSignDropdown from '../../ui/docuSignDropdown/docuSignDropdown';
import { getSignRequirements } from '../../../common/services/http/docuSignService';

interface IImpersonate {
  canImpersonate: boolean;
  impersonate: boolean;
  impersonateId: string;
  impersonateName: string;
}

const Topbar = () => {
  const [contactToggle, setContactToggle] = useState(false);
  const [signData, setSignData] = useState([]);
  const [responsiveNav, setResponsiveNav] = useState(false);
  const [impersonate, setImpersonate] = useState<IImpersonate | undefined>({
    canImpersonate: false,
    impersonate: false,
    impersonateId: '',
    impersonateName: '',
  });
  const dispatch = useDispatch();

  const handleContactToggle = () => {
    setContactToggle(!contactToggle);
  };

  const responsiveNavId = 'ResponsiveNavId';
  const docuSignDropdownId = 'DocuSignDropdownId';
  const helpToolTipId = 'HelpToolTipId';
  const userIconId = 'userIconId';

  const filterCtx: any = useContext(FilterCtx);

  const impersonateClickHandler = () => {
    dispatch({ type: IMPERSONATE_OFF });
    setImpersonationToLS('', '', '');
    filterCtx.clearAllFilters();
    useForceUpdate();
  };

  const impersonateRedux = useSelector((state: RootState) => state.impersonate);
  const docuSignDropdownRedux = useSelector((state: RootState) => state.docuSignDropdown.docuSignDropdown);

  useEffect(() => {
    // @ts-ignore
    setImpersonate(impersonateRedux);
    getSignRequirements().then((res) => {
      setSignData(res);
    });
  }, [impersonateRedux]);

  const getSignData = () => {
    getSignRequirements()
      .then((res) => {
        setSignData(res);
      })
      .then(() => {
        dispatch({ type: SWITCH_DOCUSIGN_DROPDOWN });
      });
  };

  return (
    <div className="topbar-wrapper">
      <Logo logoSource="/branding/logo.png" height={`${LogoSize.logo_size}px`} />

      <div id={'right'}>
        {signData && signData.length > 0 && (
          <div className="docusign-topbar-wrapper hidden-mobile">
            <div className="docusign-icon-wrapper pointer" id={docuSignDropdownId} onClick={getSignData}>
              <Icon name="fas fa-arrow-alt-to-bottom" className="docusign-icon" id={docuSignDropdownId} />
            </div>
            {docuSignDropdownRedux && <DocuSignDropdown signData={signData} id={docuSignDropdownId} />}
          </div>
        )}
        {impersonate.canImpersonate && (
          <Link to={'/impersonate'} className="impersonate-link" style={{ marginRight: impersonate && impersonate.impersonate === false && 25 }}>
            <Icon
              style={{ marginRight: impersonate && impersonate.impersonate === false ? 0 : 10 }}
              name={`${impersonate && impersonate.impersonate ? 'fas fa-masks-theater' : 'far fa-masks-theater'}`}
              className="impersonate-icon"
            />
            <span>{impersonate && impersonate.impersonate && `${impersonate.impersonateName}`}</span>
          </Link>
        )}
        {impersonate && impersonate.impersonate && impersonate.canImpersonate && (
          <Icon name="fas fa-xmark" className="impersonate-off-icon" onClick={impersonateClickHandler} />
        )}
        <Icon id={responsiveNavId} name={`${responsiveNav ? 'fas fa-xmark' : 'fas fa-bars'}`} className="menu-icon" onClick={() => setResponsiveNav(!responsiveNav)} />
        {responsiveNav && <ResponsiveNavigation setNav={setResponsiveNav} id={responsiveNavId} />}
        <div className="help-wrapper">
          <Icon id={helpToolTipId} name="fas fa-question-circle" className="help-icon" onClick={handleContactToggle} />
          {contactToggle && (
            <div className="contact-tooltip">
              <ContactTooltip setTooltip={setContactToggle} id={helpToolTipId} />
            </div>
          )}
        </div>
        <UserIcon id={userIconId} />
      </div>
    </div>
  );
};

export default Topbar;
